<template>
  <d-container fluid class="main-content-container p-4">
    <!-- --- COLLAPSE --- --- -- -->
    <div>
      <b-button v-b-toggle.collapse-2 class="m-1 greenbutton"><i class="fas fa-filter mr-2 "></i> Filtrer le tableau
      </b-button>
      <!-- Element to collapse -->
      <b-collapse id="collapse-2" class="mb-4">
        <d-card class="card-small">
          <d-card-body class="px-4 pb-0">
            <d-input-group class="justify-content-center">
              <c-input type="price" class="w-25" label="Tolérance" currency="XAF" v-model="inconsistencyMargin"/>
              <c-button-spinner class="inline-btn ml-1 mt-3" variant="primary" :fetching="fetchingSearch"
                                @click="onSearchSubmit">
                <template slot="icon">
                  <i class="fa fa-search"></i>
                </template>
                Rechercher
              </c-button-spinner>
            </d-input-group>
          </d-card-body>
        </d-card>
      </b-collapse>
    </div>
    <d-card class="card-small">
      <d-card-header class="px-4 pb-0">
        <d-input-group class="justify-content-center">
          <c-input class="w-25" placeholder="Rechercher par titre ou auteur..." v-model="search"/>
        </d-input-group>
      </d-card-header>
      <d-card-body class="pt-0">
        <c-table :fetching="fetchingData" :table-data="filteredData" :fields="fields" :actions="actions" :per-page="25">
          <p class="text-center" slot="empty">Aucune cagnotte incohérente trouvée.</p>
        </c-table>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import {Api, asset, formatAmount, Toast, truncate} from "@/helpers"

export default {
  title: "Incohérence des cagnottes",
  data() {
    return {
      search: '',
      inconsistencyMargin: 0,
      fetchingSearch: false,
      fetchingData: false,
      data: [],

      //table header
      fields: [
        {key: 'picture', label: 'Photo'},
        {key: 'title_pretty', label: 'Titre', sortable: true},
        {key: 'author', label: 'Auteur', sortable: true},
        {key: 'progress', label: 'Collecté / Objectif', sortable: true},
        {key: 'created_at', label: 'Créé le', sortable: true},
        {key: 'deadline_pretty', label: 'Date butoire', sortable: true},
        {key: 'status', label: 'Statut', sortable: true},
        {key: 'balance_pretty', label: 'Solde', sortable: true},
        {key: 'expected_pretty', label: 'Solde calc.', sortable: true},
        {key: 'difference_pretty', label: 'Diff.', sortable: true},
        {key: 'actions', label: 'Actions'},
      ],

      actions: [
        {
          type: 'white',
          icon: 'fas fa-exchange-alt',
          title: "Transactions de la cagnotte",
          handler: this.onRedirectToTransaction
        },
        {
          type: 'white',
          icon: 'fas fa-sync',
          title: "Synchroniser le solde",
          handler: this.onSync
        },
      ],
    }
  },
  computed: {
    filteredData() {
      const search = this.search.toLowerCase()
      return this.data.filter(item => {
        return item.entity.toLowerCase().includes(search)
          || item.balance.toLowerCase().includes(search)
          || item.expected.toLowerCase().includes(search)
          || item.difference.toLowerCase().includes(search)
      })
    },
  },
  created() {
    this.fetchingData = true
    Api.get('/scan/raisings')
      .then(res => this.data = res.data.map(this.mapItem))
      .catch(err => this.error = err)
      .then(() => this.fetchingData = false)
  },
  methods: {
    mapItem(item) {
      return {
        ...item,
        picture: asset(item.image_path),
        title_pretty: truncate(item.entity, 30),
        author: truncate(item.creator, 20) + (item.verified ? " ✔" : ""),
        balance_pretty: formatAmount(item.balance),
        progress: formatAmount(item.amount_collected) + ' / ' + formatAmount(item.target_amount),
        deadline_pretty: item.deadline.replace(' ', '\n'),
        expected_pretty: formatAmount(item.expected),
        difference_pretty: formatAmount(item.difference),
        status: item.closed ? "Clôturée" : !item.enabled ? "Bloquée" : !item.active ? "Inactive" : "Active",
        statusVariant: item.closed ? "secondary" : !item.enabled ? "danger" : !item.active ? "warning" : "success",
      }
    },
    onSearchSubmit() {
      this.fetchingSearch = true
      Api.postFormData('/scan/raisings', {margin: this.inconsistencyMargin})
        .then(res => this.data = res.data.map(this.mapItem))
        .catch(err => this.error = err)
        .then(() => this.fetchingSearch = false)
    },
    //redirect a rasing to its transactions
    onRedirectToTransaction(item) {
      this.$router.push({name: 'transactions', query: {entity: 'RAISING', id: item.id}});
    },
    // Sync raising's balance
    onSync(item) {
      Toast.loading(`Synchronisation du solde de la cagnotte "${item.entity}"...`)
      Api.postFormData('/sync_balance/raising', {raising_id: item.id})
        .then(res => {
          const raising = res.data.raising
          this.data = this.data.filter(_item => _item.id !== item.id)
          Toast.success(`Le solde de la cagnotte "${raising.title}" a été synchronisé avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => Toast.loadingToast.goAway())
    },
  }
}
</script>

<style scoped>
.picture {
  max-height: 200px;
}
</style>
